<template>
  <div class="document-style">
    <ul class="fs-16">
      <li>
        <div class="title-list-style">
          <span>Engagement & Impact</span>
        </div>
        <div>
          <div class="mt-6">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weekly usage stats of the
            organization and Real-Time weekly insight. Highlighting key
            engagement metrics such as eNPS, NPS, Wellness, Culture, and
            Employee Resilience Index scores as well as an overview of
            individual impact and manager activity.
          </div>
        </div>
        <div class="mt-24">
          <div class="fw-700">People: Impact contributors</div>
          <div>
            Green, yellow and red dots represent employee engagement and impact,
            measured from Happily app usage in various aspects.
          </div>
        </div>
        <div class="mt-12">
          <div class="fw-700">Managers: Non-active</div>
          <div>
            Green, yellow and red dots represent manager engagement, measured
            from feedback reply rate and insight opening in email.
          </div>
        </div>
        <div class="note-box">
          <div class="flex-center">
            <div
              class="fs-2 mr-6"
              style="
                width: 16px;
                height: 16px;
                border-radius: 16px;
                background-color: #35d077;
              "
            >
              &nbsp;
            </div>
            Green : open insight, frequently reply to feedback.
          </div>
          <div class="flex-center mt-4">
            <div
              class="fs-2 mr-6"
              style="
                width: 16px;
                height: 16px;
                border-radius: 16px;
                background-color: #fbc02d;
              "
            >
              &nbsp;
            </div>
            Yellow : open insight, sometimes reply to feedback.
          </div>
          <div class="flex-center mt-4">
            <div
              class="fs-2 mr-6"
              style="
                width: 16px;
                height: 16px;
                border-radius: 16px;
                background-color: #f44336;
              "
            >
              &nbsp;
            </div>
            Red : open insight, reply to feedback below standard.
          </div>
        </div>
        <div class="mt-12">
          <div class="fw-700">Culture Index</div>
          <div>
            Real-Time data from various Happily Index, the shown data will be
            alternate every day.
          </div>
        </div>
        <div class="note-box">
          <div class="fw-500">Employee Resilience Index</div>
          <div class="flex mt-4">
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Resilience - Excellence_16x16')"
              alt="icons_benchmark_Resilience - Excellence_16x16"
            />
            <span class="pr-24 opa-07">Excellence</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Resilience - Fair_16x16')"
              alt="icons_benchmark_Resilience - Fair_16x16"
            />
            <span class="pr-24 opa-07">Fair</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Resilience - Critical_16x16')"
              alt="icons_benchmark_Resilience - Critical_16x16"
            />
            <span class="pr-24 opa-07">Critical</span>
          </div>
          <div class="fw-500 mt-6">WHO-5 Wellbeing Index</div>
          <div class="flex mt-4">
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Wellness - Excellence_16x16')"
              alt="icons_benchmark_Wellness - Excellence_16x16"
            />
            <span class="pr-24 opa-07">Excellence</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Wellness - Fair_16x16')"
              alt="icons_benchmark_Wellness - Fair_16x16"
            />
            <span class="pr-24 opa-07">Fair</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Wellness - Critical_16x16')"
              alt="icons_benchmark_Wellness - Critical_16x16"
            />
            <span class="pr-24 opa-07">Critical</span>
          </div>
          <div class="fw-500 mt-6">Culture Index</div>
          <div class="flex mt-4">
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Culture - Excellence_16x16')"
              alt="icons_benchmark_Culture - Excellence_16x16"
            />
            <span class="pr-24 opa-07">Excellence</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Culture - Fair_16x16')"
              alt="icons_benchmark_Culture - Fair_16x16"
            />
            <span class="pr-24 opa-07">Fair</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'benchmark_Culture - Critical_16x16')"
              alt="icons_benchmark_Culture - Critical_16x16"
            />
            <span class="pr-24 opa-07">Critical</span>
          </div>
          <div class="fw-500 mt-6">-</div>
          <div class="flex mt-4">
            <img
              class="mr-4"
              :src="$utils('icons', 'Promoters_16')"
              alt="Promoters_16 - Excellence_16x16"
            />
            <span class="pr-24 opa-07">Excellence</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'Passives_16')"
              alt="Passives_16"
            />
            <span class="pr-24 opa-07">Fair</span>
            <img
              class="mr-4"
              :src="$utils('icons', 'Distractors_16')"
              alt="Distractors_16"
            />
            <span class="pr-24 opa-07">Critical</span>
          </div>
        </div>
        <div class="note-box">
          <div class="">
            <span class="fw-700">Happiness Rate:</span>
            <span class="ml-6">
              % of the answer ‘Happy’ or ‘Pretty Good’ on the ‘How are you
              feeling today?’ question.
            </span>
          </div>
          <div class="mt-6">
            <span class="fw-700">Risk Rate:</span>
            <span class="ml-6">
              % of people that says ‘Not Good’ and ‘Terrible’ on the ‘How are
              you feeling today?’ question.
            </span>
          </div>
          <div class="mt-6">
            <span class="fw-700">Open-ended Feedback Response Rate:</span>
            <span class="ml-6">
              The percent of people who answer daily open-ended questions in a
              week.
            </span>
          </div>
        </div>
        <div class="fw-700 mt-24">Activity</div>
        <div class="note-box">
          <div class="flex">
            <span class="fw-700">Adoption:</span>
            <span class="ml-6">
              the percentage of people who adopt happily Application.
            </span>
          </div>
          <div class="mt-6">
            <span class="fw-700">Active Users (Monthly/Weekly):</span>
            <span class="ml-6">
              The amount of people who use Happily Application per month or
              week.
            </span>
          </div>
        </div>
        <!-- <div class="fs-12 opa-06">Billing (alpha)</div> -->
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>By Job Tenure</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Highlighting key groups that
              exhibit high or low scores in happiness, risk, feedback rate, or
              activity.
            </div>
          </div>
          <div class="mt-24 flex">
            <div class="fw-700">Job Tenure:</div>
            <div class="ml-6">
              The duration of time an employee has worked at the company.
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              You can hover on the bars to see the more details [Weekly Active,
              Happiness, Risk and Open-Feedback Rate].
            </span>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>Real-time Activity</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Showing real-time active users
              on Happily Application.
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span
              >Hover on Line to see the ative user record from Happily
              Application.</span
            >
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>Key Teams & Cohorts </span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Shows Real-Time weekly data
              and highlight key groups that exhibit significant score on some
              aspects
            </div>
          </div>
          <div class="note-box">
            <div class="fw-700">Priority of highlight key</div>
            <div class="flex">
              <div class="ml-12">
                <div>1.) HIGH RISK</div>
                <div>2.) LOW ACTIVITY</div>
                <div>3.) LOW FEEDBACK</div>
                <div>4.) LOW HAPPINESS</div>
              </div>
              <div class="ml-32">
                <div>5.) HIGH ACTIVITY</div>
                <div>6.) HIGH FEEDBACK</div>
                <div>7.) HIGH HAPPINESS</div>
                <div>8.) LOW RISK</div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>Tone Analyzer</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Show the top 5 tones and
              emotions, analyzed from the answer to open-ended questions.
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>Hover on each tone to see description.</span>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>Talking Points</span>
          </div>
          <div>
            <div class="mt-6">
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Trends and topics from
              employees within the last 30 days
            </div>
          </div>
          <div class="note-box">
            <div class="flex-center">
              <div
                class="px-8 mr-6"
                style="
                  color: #249d2a;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #edffee;
                  border-radius: 4px;
                "
              >
                Positive
              </div>
              <div>= ????</div>
            </div>
            <div class="flex-center mt-4">
              <div
                class="px-8 mr-8"
                style="
                  color: #484848;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #f0f0f0;
                  border-radius: 4px;
                "
              >
                Neutral
              </div>
              <div>= ????</div>
            </div>
            <div class="flex-center mt-4">
              <div
                class="px-8 mr-10"
                style="
                  color: #f44336;
                  font-weight: 700;
                  box-shadow: 0px 2px 4px #0000002d;
                  background-color: #ffedeb;
                  border-radius: 4px;
                "
              >
                Critical
              </div>
              <div>= ????</div>
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              You can see the record of employees talking points and interests
              in all dimensions from the past months by click on
              <span class="fw-700">"show timeline"</span> label.
            </span>
          </div>
        </div>
      </li>
      <li>
        <div class="mt-32">
          <div class="title-list-style">
            <span>Engagement Breakdown by Team</span>
          </div>
          <div class="mt-12">
            <span class="fw-700">Dimension:</span>
            <span>
              aspects that can help measure the engagement of employees within
              an organization
            </span>
          </div>
          <div class="mt-6">
            <span>
              The questions below each dimension are the main questions for
              calculating data into green, yellow, or red dots.
            </span>
          </div>
          <div class="note-box">
            <div class="link-ref" @click="channgeMenu('Keynote_Dimension')">#Dimension</div>
            <div class="fw-700 mt-4">
              How to calculate Success Score (out of 100)
            </div>
            <div class="flex-center">
              <div
                style="
                  border: 1px solid #000;
                  padding: 4px 0 4px 4px;
                  border-right: 0;
                  height: 34px;
                "
              ></div>
              <div>
                <div class="center">
                  (
                  <span style="color: #66bb6a"
                    >(number of green teams x 1)</span
                  >
                  +
                  <span style="color: #fbc02d"
                    >(number of yellow teams x 0.5)</span
                  >
                  +
                  <span style="color: #f44336">(number of red teams x 0)</span>
                  )
                </div>
                <div class="center" style="border-top: 1px solid #000">
                  Number of all teams in the dimension
                </div>
              </div>
              <div
                style="
                  border: 1px solid #000;
                  padding: 4px 0 4px 4px;
                  border-left: 0;
                  height: 34px;
                "
              ></div>
              <div class="pr-4 pl-4">x 100</div>
              <div class="pr-4">=</div>
              <div class="fw-700">Success Score</div>
            </div>
          </div>
          <div class="tip-box">
            <span class="note-header">Note:</span>
            <span>
              Click on each dimension to see Success Score and Talking Points
              record from the past 30 days/ 1 years.
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
  
<script>
export default {
  data() {
    return {};
  },
  methods: {
    channgeMenu(menu) {
      this.$emit("changedMenu", menu);
    }
  },
};
</script>
  
<style lang="scss" scoped></style>